import {ConversationMessageType, type Message} from '@/client/mentor/MessagesClient'
import {DATE_TIME_FMT, useDateTimeFormatter} from '@/composable/useDateTimeFormatter'
import {useUserStore} from '@/stores/user'
import {computed} from 'vue'
import {useI18n} from 'vue-i18n'

export function useAssistantChatPrintContext() {
  const {t} = useI18n()
  const userStore = useUserStore()
  const [dateTimeFormatter] = useDateTimeFormatter(DATE_TIME_FMT)

  const userFullName = computed(() =>
    [userStore.properties.firstname, userStore.properties.lastname].filter(Boolean).join(' ').trim()
  )
  const assistantSenderLabel = computed(() => t('assistant.chat.message.printSender.assistant'))
  const systemSenderLabel = computed(() => t('assistant.chat.message.printSender.system'))

  function getPrintSenderLabel(message: Message) {
    if (message.type === ConversationMessageType.USER) {
      return userFullName.value || userStore.username || ''
    }

    if (message.type === ConversationMessageType.ASSISTANT) {
      return assistantSenderLabel.value
    }

    return systemSenderLabel.value
  }

  function getPrintTimestamp(message: Message) {
    return dateTimeFormatter.value.format(message.createdAt)
  }

  return {
    getPrintSenderLabel,
    getPrintTimestamp,
  }
}
